import { motion } from "framer-motion";
import { useLang } from "../lib/i18n";

const EASE = [0.34, 1.56, 0.64, 1];

export default function Serve() {
  const { t } = useLang();
  return (
    <div className="mt-28" data-testid="who-we-serve-section">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
          {t.servePre} <em className="font-serif italic font-medium text-brasslight">{t.serveAccent}</em>
        </h2>
        <p className="mt-4 text-base md:text-lg text-taupe">{t.serveSub}</p>
      </motion.div>

      <div className="mt-10 flex flex-wrap gap-3">
        {t.servePills.map((s, i) => (
          <motion.span
            key={s}
            initial={{ opacity: 0, scale: 0.6, y: 14 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.07, ease: EASE }}
            className="cursor-default rounded-full border border-cream/15 bg-cream/5 px-5 py-2.5 font-display text-sm font-semibold text-cream/85 transition-colors duration-300 hover:bg-cream hover:text-ink"
            data-testid={`serve-pill-${i}`}
          >
            {s}
          </motion.span>
        ))}
      </div>
    </div>
  );
}
